<template>
  <div>
    <div class="landing-box">
      {{ msg }}
    </div>
  </div>
</template>

<script>
import {
  customerLogin,
  orderDetail,
  selfSolveTaskDetail,
} from "@/common/api.js";
import { cookieSet } from "@/common/cookie";

export default {
  data() {
    return {
      orderNo: "",
      tokenKey: "",
      taskNo: "",
      msg: "正在处理订单信息...",
    };
  },
  mounted() {
    const { taskNo, tokenKey } = this.$route.params;
    if (taskNo && tokenKey) {
      this.taskNo = taskNo;
      this.tokenKey = tokenKey;
      this.getToken();
    } else {
      this.msg = "缺失必要参数";
    }
  },
  methods: {
    async getToken() {
      this.msg = "正在获取token...";
      if (!this.tokenKey) {
        this.msg = "缺失tokenKey";
        return;
      }
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      try {
        const data = await customerLogin({
          key: this.tokenKey,
        });
        this.$toast.clear();
        if (data) {
          cookieSet("token", data.token);
          this.getTaskDetail();
        }
      } catch (error) {
        this.$toast.clear();
        const msg = error.data.message || "获取token失败";
        this.msg = msg;
        console.log(error);
      }
    },
    async getTaskDetail() {
      this.msg = "正在获取订单信息...";
      if (!this.taskNo) {
        this.msg = "缺失taskNo";
        return;
      }
      this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      try {
        const data = await selfSolveTaskDetail({
          taskNo: this.taskNo,
        });
        this.$toast.clear();
        if (data && data.orderNo) {
          this.orderNo = data.orderNo;
          this.toPage();
        } else {
          this.msg = "获取订单信息失败";
        }
      } catch (error) {
        this.$toast.clear();
        this.msg = "获取订单信息失败";
        console.log(error);
      }
    },
    toPage() {
      // 跳转到客户自解详情页，传递orderNo和taskNo
      this.$router.replace({
        path: "/customerSelfHelp",
        query: {
          orderNo: this.orderNo,
          taskNo: this.taskNo,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.landing-box {
  margin-top: 100px;
  text-align: center;
  font-size: 16px;
}
</style>
